export default __webpack_public_path__ + "static/media/13.87276bd6.jpg";